import { render, staticRenderFns } from "./NormItem.vue?vue&type=template&id=1890a6ca&scoped=true"
import script from "./NormItem.vue?vue&type=script&lang=js"
export * from "./NormItem.vue?vue&type=script&lang=js"
import style0 from "./NormItem.vue?vue&type=style&index=0&id=1890a6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.14_css-loader@6.11.0_webpack@5.99.8__ejs@3.1.10_loda_tabtodhn2upniikejzvtfgbz5m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1890a6ca",
  null
  
)

export default component.exports